const PUBLIC_URL = process.env.PUBLIC_URL || '';

const parseDomains = (value) =>
  (value || '')
    .split(',')
    .map((domain) => domain.trim().toLowerCase().replace(/^@/, ''))
    .filter(Boolean);

export const ORGANIZATION_BRAND = {
  name: 'Koloğlu Holding',
  portalName: 'Koloğlu Holding İntranet',
  logoPath: `${PUBLIC_URL}/kologlu.png`,
  academyUrl: process.env.REACT_APP_ACADEMY_URL || 'https://akademi.kologlu.com.tr'
};

export const DEFAULT_EMAIL_DOMAINS = ['kologlu.com.tr', 'kolin.com.tr'];

export const ALLOWED_EMAIL_DOMAINS =
  parseDomains(process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS).length > 0
    ? parseDomains(process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS)
    : DEFAULT_EMAIL_DOMAINS;

export const corporateEmailPlaceholder = `ad.soyad@${ALLOWED_EMAIL_DOMAINS[0]}`;

export const isAllowedCorporateEmail = (email = '') => {
  const domain = email.trim().toLowerCase().split('@')[1];
  return ALLOWED_EMAIL_DOMAINS.includes(domain);
};
